import React, { FC, useEffect } from 'react'
import AppTabs from './components/AppTabs'
import {
  Routes,
  Navigate,
  Route,
  useSearchParams,
  useNavigate,
} from 'react-router-dom'
import Login from './pages/Login'
import Signup from './pages/Signup'
import { verifyToken } from './redux/appReducer'
import { connect } from 'react-redux'
import { EnqueueSnackbarType } from './components/common/Helpers'
import { useSnackbar } from 'notistack'
import Profile from './pages/Profile/Profile'
import { actions as appActions } from './redux/appReducer'
import Forgot from './pages/Forgot'
import { StateType } from './redux/store'

interface IProps {
  isDataFetched: boolean

  verifyToken(token: string, enqueueSnackbar: EnqueueSnackbarType): void
  setIsGSH(value: boolean): void
  openMaterialGroupDetails(id: number): void
}

const App: FC<IProps> = (props) => {
  const { enqueueSnackbar } = useSnackbar()

  const [searchParams] = useSearchParams()
  const navigate = useNavigate()

  useEffect(() => {
    if (localStorage.getItem('sceneID')) {
      props.verifyToken(localStorage.getItem('sceneID') || '', enqueueSnackbar)
    }

    const dir = searchParams.get('dir')
    if (dir) {
      if (dir.startsWith('signup') || dir.startsWith('forgot')) {
        navigate('/' + dir)
      } else
        switch (dir) {
          case 'login':
            navigate('/login')
            break
          case 'profile':
            navigate('/profile')
            break
        }
    }

    if (
      window.location.origin.includes('thegarageshop.com') ||
      window.location.origin.includes('localhost')
    ) {
      props.setIsGSH(true)
    }
  }, [])

  useEffect(() => {
    if (props.isDataFetched) {
      const dir = searchParams.get('dir')
      const id = searchParams.get('id')
      if (dir === 'mgroup' && id) {
        props.openMaterialGroupDetails(Number(id))
      }
    }
  }, [props.isDataFetched])

  return (
    <Routes>
      <Route path="/" element={<AppTabs />} />
      <Route path="/login" element={<Login />} />
      <Route path="/signup" element={<Signup />} />
      <Route path="/signup/:email" element={<Signup />} />
      <Route path="/forgot" element={<Forgot />} />
      <Route path="/forgot/:code" element={<Forgot />} />
      <Route path="/profile" element={<Profile />} />
      <Route path="/error" element={<>error</>} />
      <Route path="/error/g1" element={<>error g1</>} />
      <Route path="/error/g2" element={<>error g2</>} />
      <Route path="*" element={<Navigate to="/" />} />
    </Routes>
  )
}

const mapStateToProps = (state: StateType) => ({
  isDataFetched: state.appReducer.isDataFetched,
})

export default connect(mapStateToProps, {
  verifyToken,
  setIsGSH: appActions.setIsGSH,
  openMaterialGroupDetails: appActions.openMaterialGroupDetails,
})(App)
